import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';

import { type BdFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<BdFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12"
            label="Discipline (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />
    </>
  );
}
